import {Component} from '@angular/core';

declare var jQuery:any;

@Component({
    selector: 'nomenu',
    templateUrl: 'nomenu.template.html'
})
export class nomenuComponent {}


// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/layout/layouts/nomenu.component.ts